import axios, { AxiosResponse } from 'axios';
import { SNRResponse } from './types/SNRResponse';

export const BASE = '/services/isnaportalsync/open-api/snr-search';

export const getSNRByUin = (token: string, uin: string) => {
    return axios.get(BASE, {
        headers: { Authorization: token },
        params: { uin },
    });
};
